import { useTranslation } from 'react-i18next';
import { Button, FieldError, Form, Input, Label, TextField } from 'react-aria-components';
import { LoadingPage } from '@pages/loading-page/LoadingPage';
import { LoginMode } from '@features/authentication/types/LoginMode';
import { useLoginPage } from '@features/authentication/login-page/useLoginPage';



export const LoginPage = () => {
	const { t } = useTranslation('global');

	const [ loginMode, isLoading, handleSubmit, validateEmail ] = useLoginPage();


	if (isLoading || loginMode === LoginMode.checkToken) return (
		<LoadingPage />
	)


	return (
		<div className="app-login-page">

			<h1>{t('authentication.loginPage.header')}</h1>
			
			<Form onSubmit={handleSubmit}>

				<TextField name='username' type='email' inputMode='email' validate={validateEmail} isDisabled={isLoading} isRequired>
					<Label>{t('authentication.loginPage.emailLabel')}</Label>
					<Input maxLength={50} placeholder={t('authentication.loginPage.emailPlaceholder')} />
					<FieldError />
				</TextField>
				
				<TextField name='password' type='password' isDisabled={isLoading} isRequired>
					<Label>{t('authentication.loginPage.passwordLabel')}</Label>
					<Input maxLength={100} placeholder={t('authentication.loginPage.passwordPlaceholder')} />
					<FieldError />
				</TextField>
			
				<div>
					<Button type='submit' isDisabled={isLoading}>{t('authentication.loginPage.submitButton')}</Button>
				</div>
			
			</Form>

			{loginMode === LoginMode.loginFailed &&
				<p>{t('authentication.loginPage.failedWarning')}</p>}

		</div>
	)
}